import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { Box, LinearProgress, Typography } from '@mui/material';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import PropTypes from 'prop-types';
import React, { Suspense, useEffect, useState } from 'react';
import { renderRoutes } from 'react-router-config';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { getMenu } from 'src/utils/storage/NavBarAdet';
import NavBar, { NAVBAR_WIDTH } from './NavBar';
import TopBar from './TopBar';
import { ROLES_UPDATED_EVENT } from 'src/utils/roleSync';

const ORANGE = '#FF9800';
const HOME_PATH = '/Kullanici';

// Sayfa üstündeki küçük breadcrumb
function PageHeader({ section, item }) {
  return (
    <Box sx={{ px: { xs: 1.5, sm: 3 }, pt: 2.5, pb: 2, fontFamily: 'Segoe UI' }}>
      <Breadcrumbs
        separator={<NavigateNextIcon sx={{ fontSize: 16, color: '#b0bec5' }} />}
        aria-label="breadcrumb"
        sx={{ '& .MuiBreadcrumbs-li': { display: 'flex', alignItems: 'center' }, '& .MuiBreadcrumbs-separator': { mx: 0.5 } }}
      >
        <Link
          component={RouterLink}
          to={HOME_PATH}
          underline="none"
          sx={{ display: 'flex', alignItems: 'center', gap: 0.5, fontSize: '12px', fontWeight: 600, color: '#78909c', '&:hover': { color: ORANGE } }}
        >
          <HomeOutlinedIcon sx={{ fontSize: 16 }} />
          Dia
        </Link>
        {section && (
          <Typography sx={{ fontSize: '12px', fontWeight: 600, color: '#78909c' }}>
            {section.title}
          </Typography>
        )}
        {item && (
          <Typography sx={{ fontSize: '12px', fontWeight: 600, color: '#ef6c00' }}>
            {item.title}
          </Typography>
        )}
      </Breadcrumbs>
    </Box>
  );
}

function Dashboard({ route }) {
  const location = useLocation();
  const [openNavBar, setOpenNavBar] = useState(true);
  const Menu = getMenu();
  const Tab = Menu.find(i => i.items.find(j => j.href === location.pathname));
  const currentItem = Tab?.items.find(j => j.href === location.pathname);
  const [topBarRotation, setTopBarRotation] = useState(true)
  // Yetkiler yenilenince menü ve sayfa yeni yetkilerle yeniden çizilsin (F5 gerekmesin)
  const [, setRolesVersion] = useState(0);

  useEffect(() => {
    const onRolesUpdated = () => setRolesVersion((v) => v + 1);
    window.addEventListener(ROLES_UPDATED_EVENT, onRolesUpdated);
    return () => window.removeEventListener(ROLES_UPDATED_EVENT, onRolesUpdated);
  }, []);

  function changeTopBarRotation() {
    setTopBarRotation(!topBarRotation)
  }

  return (
    <>
      <TopBar onOpenNavBar={() => setOpenNavBar(!openNavBar)}
        topBarRotation={topBarRotation}
        changeTopBarRotation={() => changeTopBarRotation()}
      />
      <NavBar open={openNavBar} Menu={Menu}
        onOpenNavBar={() => setOpenNavBar(!openNavBar)}
        changeTopBarRotation={() => changeTopBarRotation()}
      />
      <div>
        <div style={{ paddingLeft: openNavBar ? NAVBAR_WIDTH : 0 }}>
          <PageHeader section={Tab} item={currentItem} />
          <Suspense fallback={<LinearProgress />}>
            {renderRoutes(route.routes)}
          </Suspense>
        </div>
      </div>
    </>
  );
}

Dashboard.propTypes = {
  route: PropTypes.object
};

export default Dashboard;
